import { SchemaSMSDraftService } from './service';
import { QueryEndpointName } from './types';

export const STANDARD_QUERY_ENDPOINT_NAMES = [
  'Get',
  'ListDraftsCount',
] as const satisfies (keyof typeof SchemaSMSDraftService)[];

export const INFINITE_QUERY_ENDPOINT_NAMES = ['ListDrafts'] as const satisfies (keyof Omit<
  typeof SchemaSMSDraftService,
  (typeof STANDARD_QUERY_ENDPOINT_NAMES)[number]
>)[];

export const QUERY_ENDPOINT_NAMES = [...STANDARD_QUERY_ENDPOINT_NAMES, ...INFINITE_QUERY_ENDPOINT_NAMES] as const;

export const MUTATION_ENDPOINT_NAMES = ['Upsert', 'Delete'] as const satisfies (keyof Omit<
  typeof SchemaSMSDraftService,
  QueryEndpointName
>)[];
